import CxDropdownMenu from '../Dropdown/dropdown-menu.vue'

export default CxDropdownMenu



// WEBPACK FOOTER //
// ./src/components/DropdownMenu/index.js